import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31ceac30"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "opening" }, null, -1))

import { onMounted, nextTick } from 'vue';
import { useOpening } from '@/store';
import { storeToRefs } from 'pinia';
import CloseBtn from '../base/CloseBtn.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'OpeningVideo',
  props: {
    youtube: null
  },
  setup(__props: any) {

const props = __props as {
  youtube: string;
}

const { player, isPlaying } = storeToRefs(useOpening());
const { updateIsPlaying } = useOpening();

const checkIsFirstPlay = !window.localStorage.getItem('isFirstPlay');
function onPlayerReady(event) {
  if (checkIsFirstPlay) {
    event.target.mute();
  }
  event.target.playVideo();
}
function onPlayerStateChange(event) {
  if (isPlaying.value) {
    document.body.style.overflow = 'hidden';
  }
  if (event.data == window.YT.PlayerState.ENDED) {
    if (!window.localStorage.getItem('isFirstPlay')) {
      window.localStorage.setItem('isFirstPlay', 'false');
    }
    updateIsPlaying(false);
    document.body.style.overflow = '';
  }
}
function onYouTubeIframeAPIReady() {
  player.value = new window.YT.Player('opening', {
    height: '100%',
    width: '100%',
    videoId: props.youtube,
    playerVars: {
      fs: 0,
      controls: 0,
      enablejsapi: 1,
      origin: window.location.origin,
      // eslint-disable-next-line @typescript-eslint/camelcase
      iv_load_policy: 3,
      modestbranding: 1,
      playsinline: 1,
      autoplay: 1,
      rel: 0,
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerStateChange,
    },
  });
}
function closeOpening() {
  updateIsPlaying(false);
  window.localStorage.setItem('isFirstPlay', 'false');
}
onMounted(async () => {
  await nextTick();
  if (window.YT) onYouTubeIframeAPIReady();
  window.onYouTubePlayerAPIReady = onYouTubeIframeAPIReady;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['youtube', { ended: !_unref(isPlaying) }])
  }, [
    _hoisted_1,
    _createVNode(CloseBtn, { onClick: closeOpening })
  ], 2))
}
}

})